import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CustomRadioField, CustomSelectField } from '../../../components';
import formUtils from '../../../utils/formUtils';

function ProofSection({ militaryEnums, collected_attributes, intl, hasVeteranStatusProof }) {
  return (
    <>
      {collected_attributes.military_proof_of_veteran_status && (
        <CustomRadioField
          name="military.proof_of_veteran_status"
          label={<FormattedMessage id="+Jybhz" description="proofOfVetStatus" defaultMessage="Proof of veteran status?" />}
          id="uu_contact_military_proof_of_veteran_status"
          options={formUtils.translateOptions(intl, militaryEnums.proof_of_veteran_status)}
        />
      )}
      {hasVeteranStatusProof && collected_attributes.military_proof_type && (
        <CustomSelectField
          name="military.proof_type"
          id="uu_contact_military_proof_type"
          label={<FormattedMessage id="rpyYaU" description="proofType" defaultMessage="Proof Type" />}
          options={formUtils.translateOptions(intl, militaryEnums.proof_type)}
        />
      )}
    </>
  );
}

ProofSection.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  collected_attributes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  hasVeteranStatusProof: PropTypes.bool.isRequired,
};

export default ProofSection;
